import React from 'react';
import { ThemeConsumer } from 'styled-components';

const PersonalTransporter: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <ThemeConsumer>
      {(theme) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="94"
          fill="none"
          viewBox="0 0 122 94"
        >
          <path
            fill={theme.primary[50]}
            d="M74.622 0H47.467C30.088 0 16 14.07 16 31.424V62.12c0 17.355 14.088 31.424 31.467 31.424h27.155c17.379 0 31.467-14.069 31.467-31.424V31.425C106.089 14.068 92.001 0 74.622 0z"
          ></path>
          <path
            stroke={theme.primary[100]}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 80.769h120"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M43.938 36.384a.812.812 0 00-.813-.812 3.25 3.25 0 01-3.25-3.25.812.812 0 10-1.625 0 4.88 4.88 0 004.875 4.875.812.812 0 00.813-.813zM42.547 27.682a.816.816 0 001.154 1.154.855.855 0 00.236-.577.84.84 0 00-.236-.577.85.85 0 00-1.154 0zM66.11 61.807a.813.813 0 101.154 1.144.813.813 0 00-1.153-1.144z"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M86.91 59.488a8.11 8.11 0 00-14.249-.355H54.024l-7.94-7.94 5.955-24.367a.813.813 0 00-.708-1.006l-7.6-.76a3.293 3.293 0 00-.606-.052c-.164 0-.327.017-.487.05a3.237 3.237 0 00-2.726 2.825l-1.424 1.425a.813.813 0 101.149 1.148l.65-.65a3.22 3.22 0 005.635.077h.453L40.2 55.105c-.081 0-.163-.006-.244 0a8.139 8.139 0 00-2.88.803.812.812 0 00-.218 1.304l1.034 1.027a5.688 5.688 0 108.483 4.956 5.652 5.652 0 00-2.143-4.433l.602-2.46 2.83 2.83h-.477a.812.812 0 100 1.626h.477l2.198 2.2 2.438 2.437a.812.812 0 00.575.238h21.694a5.668 5.668 0 0010.741-1.625h.877a.812.812 0 00.813-.813v-3.33c0-.132-.03-.26-.09-.377zM43.125 29.883a1.621 1.621 0 01-.202-3.23h.041c.047-.01.094-.016.142-.02l.363.037c.195.042.382.12.549.231.023.015.044.034.067.05.056.041.11.085.162.132.027.026.051.054.076.081a1.651 1.651 0 01.182.24c.03.05.057.1.082.15.018.038.036.075.05.114.023.059.042.119.057.18.009.035.021.069.028.104.019.101.028.203.028.306a1.61 1.61 0 01-.103.542c0 .01 0 .023-.008.034a1.625 1.625 0 01-1.514 1.049zm4.925-1.314a.813.813 0 00-.638-.311h-1.037c0-.226-.025-.452-.072-.673-.01-.051-.032-.097-.046-.147a3.21 3.21 0 00-.162-.48c0-.008-.004-.017-.008-.024l4.144.414-5.835 23.904-.038.162-1.832 7.486-1.002 4.102a.803.803 0 00-.024.193.812.812 0 11-1.625 0 .805.805 0 01.091-.358.802.802 0 00.062-.17l1.011-4.131.578-2.362 6.581-26.909a.812.812 0 00-.148-.697v.001zm-9.156 28.377c.298-.084.6-.147.907-.189l-.21.86-.02.005-.677-.676zm4.896 3.628a4.063 4.063 0 11-4.646-1.141l-.675 2.766a2.398 2.398 0 00-.219.996 2.438 2.438 0 104.875.108l.665-2.729zm1.764-7.216l.08-.325 6.095 6.094H49.96l-4.676-4.676.269-1.093zm34.133 13.9a4.063 4.063 0 01-3.244-1.625h3.245a2.437 2.437 0 100-4.875h-3.245a4.061 4.061 0 113.245 6.5zm5.688-4.875h-.058c-.009-.063-.025-.124-.035-.185-.014-.078-.027-.154-.044-.23a3.993 3.993 0 00-.082-.307c-.02-.071-.038-.143-.06-.212-.035-.108-.075-.212-.115-.317l-.07-.182a5.96 5.96 0 00-.172-.354c-.021-.04-.038-.081-.06-.12a5.514 5.514 0 00-.274-.452c-.018-.026-.038-.05-.057-.076a4.304 4.304 0 00-.257-.345c-.038-.046-.081-.09-.12-.135a4.925 4.925 0 00-.23-.254c-.048-.049-.1-.094-.148-.141-.081-.073-.156-.147-.237-.216a9.573 9.573 0 00-.412-.32c-.06-.042-.124-.08-.185-.122-.086-.056-.172-.108-.26-.163a5.72 5.72 0 00-.474-.241c-.069-.031-.137-.062-.207-.09a5.996 5.996 0 00-.294-.108c-.07-.024-.14-.05-.21-.07a5.866 5.866 0 00-.32-.082c-.068-.016-.136-.034-.206-.047a5.607 5.607 0 00-.362-.056c-.06-.008-.119-.02-.18-.025A5.696 5.696 0 0074.33 61.3a.812.812 0 00.767 1.084h4.591a.813.813 0 010 1.625H53.212l-.812-.813h11.038a.812.812 0 100-1.625H50.775l-.813-.812h23.185a.813.813 0 00.731-.45 6.486 6.486 0 0111.498-.245v2.32z"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M59.375 36.384h4.062v5.688a.812.812 0 001.54.363l4.874-9.75a.812.812 0 00-.726-1.176h-4.063v-5.687a.812.812 0 00-1.543-.364l-4.875 9.75a.813.813 0 00.73 1.176zm4.062-7.12v3.058a.813.813 0 00.813.812h3.56l-2.748 5.495v-3.057a.812.812 0 00-.812-.813h-3.56l2.747-5.496z"
          ></path>
          <rect
            width="2"
            height="8"
            x="76"
            y="41"
            fill={theme.primary[500]}
            rx="1"
          ></rect>
          <rect
            width="2"
            height="8"
            x="73"
            y="46"
            fill={theme.primary[500]}
            rx="1"
            transform="rotate(-90 73 46)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="37.639"
            y="40.81"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(45 37.639 40.81)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="32.81"
            y="42.018"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(-45 32.81 42.018)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="71.639"
            y="13.81"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(45 71.639 13.81)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="66.811"
            y="15.018"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(-45 66.81 15.018)"
          ></rect>
          <circle
            cx="89.5"
            cy="73.5"
            r="2.5"
            fill={theme.primary[500]}
          ></circle>
          <circle cx="35" cy="20" r="2" fill={theme.primary[500]}></circle>
          <circle
            cx="24.5"
            cy="64.5"
            r="1.5"
            fill={theme.primary[500]}
          ></circle>
        </svg>
      )}
    </ThemeConsumer>
  );
};

export default PersonalTransporter;
